import React from "react";
import styled, { ThemeProviderProps, withTheme } from "styled-components";
import { ClipLoader } from "react-spinners";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  justify-content: center;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 1rem;
`;

const Text = styled.h1`
  font-size: 1rem;
  text-align: center;
`;

const LoadingWrapper = styled.div`
  padding: 1rem;
`;

interface IProps extends ThemeProviderProps<any> {
  message?: string;
}
const Loader: React.SFC<IProps> = ({ message, theme }) => {
  return (
    <Container>
      <LoadingWrapper>
        <ClipLoader color={"white"} size={35} />
      </LoadingWrapper>
      <Text>{message}</Text>
    </Container>
  );
};

export default withTheme(Loader);
